import React, { useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router';
import { useParams } from "react-router-dom";
import { phoneValidator } from '../../utils/validators';
import { unauthHeaders } from '../../utils/API';
import Forgot from './Forgot';

const ForgotContainer = () => {
    const history = useHistory();

    const { step } = useParams();

    const [isLoading, setIsLoading] = useState(false);
    const [phone, setPhone] = useState(sessionStorage.getItem('forgot_userName'));
    const [code, setCode] = useState();
    const [password, setPassword] = useState();
    const [confirmedPassword, setConfirmedPassword] = useState();

    const [isShowPassword, setIsShowPassword] = useState(false);

    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const [successMessage, setSuccessMessage] = useState();


    const checkPhone = () => {
        let customErr = { code: '', message: '' };
        if (!phoneValidator(phone, customErr)) {
            setIsError(true);
            setErrorMessage(customErr.message);
            return;
        }

        setIsLoading(true);
        const userName = parseInt(phone.replace(/\D+/g, ""))
        axios.get(`${process.env.REACT_APP_API}api/v1.0/auth/check/${userName}`, {
            headers: {
                ...unauthHeaders,
            }
        })
            .then((res) => {
                setIsLoading(false);
                if (res.data.found) {
                    getSms();
                } else {
                    setErrorMessage(res.data.message);
                }
            })
            .catch((err) => {
                console.log(err);
                setErrorMessage(err.response.data.message);
                setIsLoading(false);
            });
    }

    const getSms = () => {
        let customErr = { code: '', message: '' };
        if (!phoneValidator(phone, customErr)) {
            setIsError(true);
            setErrorMessage(customErr.message);
            return;
        }

        setIsLoading(true);
        const userName = parseInt(phone.replace(/\D+/g, ""))
        axios.get(`${process.env.REACT_APP_API}api/v1.0/auth/password/forgot/${userName}`, {
            headers: {
                ...unauthHeaders,
            }
        })
            .then((res) => {
                setIsLoading(false);
                sessionStorage.setItem('forgot_userName', userName);
                setSuccessMessage('Ожидайте СМС с кодом подтверждения');
                history.push('2');
            })
            .catch((err) => {
                console.log(err);
                setErrorMessage(err.response.data.message);
                setIsLoading(false);
            });
    }

    const getCheckCode = () => {
        if (!code) {
            setErrorMessage('Пожалуйста, введите код из СМС');
            return;
        }

        setIsLoading(true);
        const userName = sessionStorage.getItem('forgot_userName');
        axios.post(`${process.env.REACT_APP_API}api/v1.0/auth/sms/check`, {
            UserName: userName,
            Token: code,
        }, {
            headers: {
                ...unauthHeaders,
            }
        })
            .then((res) => {
                setIsLoading(false);
                sessionStorage.setItem('forgot_token', code);
                history.push('3');
            })
            .catch((err) => {
                console.log(err);
                setErrorMessage(err.response.data.message);
                setIsLoading(false);
            });
    }

    const setNewPassword = () => {
        if (!password || !confirmedPassword) {
            setErrorMessage('Пожалуйста, введите новый пароль в оба поля');
            return;
        }
        if (password !== confirmedPassword) {
            setErrorMessage('Ввeденные пароли не совпадают!');
            return;
        }
        if (password.length < 8) {
            setErrorMessage('Неверная длина пароля. Минимальная длина 8 симоволов');
            return;
        }
        if (password.length > 16) {
          setErrorMessage('Неверная длина пароля. Максимальная длина 16 симоволов');
          return;
      }
        if (!/[a-z]/.test(password) || !/[A-Z]/.test(password) || !/\d/.test(password) || !/\W/.test(password)) {
            setErrorMessage('Пожалуйста, убедитесь, что ваш пароль содержит строчные латинские буквы, заглавные латинские буквы и цифры и знаки препинания');
            return;
        }
        if (!sessionStorage.getItem('forgot_userName') || !sessionStorage.getItem('forgot_token')) {
            setErrorMessage('Извините, что-то пошло не так. Попробуйте начать процедуру восстановления пароля сначала');
            return;
        }

        const userName = sessionStorage.getItem('forgot_userName');
        const token = sessionStorage.getItem('forgot_token');

        setIsLoading(true);
        axios.post(`${process.env.REACT_APP_API}api/v1.0/auth/password/reset`, {
            UserName: userName,
            Token: token,
            Password: password,
            ConfirmPassword: confirmedPassword
        }, {
            headers: {
                ...unauthHeaders,
            }
        })
            .then((res) => {
                sessionStorage.removeItem('forgot_token');
                setIsLoading(false);
                history.push(`${process.env.REACT_APP_WEBSITE_NAME}/auth`);
            })
            .catch((err) => {
                console.log(err);
                setErrorMessage(err.response.data.message);
                setIsLoading(false);
            });
    }

    const onChangePhone = (e) => {
      setPhone(e);
      sessionStorage.setItem('forgot_userName', e);
    }


    const onClickNext = () => {
        setErrorMessage('');

        switch (step) {
            case '1':
                checkPhone();
                break;
            case '2':
                setSuccessMessage('');
                getCheckCode();
                break;
            case '3':
                setNewPassword();
                break;
            default:
                break;
        }
    }

    return (
        <>
            <Forgot
                step={step}
                isLoading={isLoading}
                phone={phone}
                setPhone={onChangePhone}
                code={code}
                setCode={setCode}
                password={password}
                setPassword={setPassword}
                confirmedPassword={confirmedPassword}
                setConfirmedPassword={setConfirmedPassword}

                isShowPassword={isShowPassword}
                setIsShowPassword={setIsShowPassword}

                isError={isError}

                onClickNext={onClickNext}
                errorMessage={errorMessage}
                successMessage={successMessage}
            />
        </>
    )
}

export default ForgotContainer;
